import hForm from './src/h-form'

hForm.install = function (Vue) {
  Vue.component(hForm.name, hForm);
};

export default hForm;